import React,{useState,useEffect} from 'react'

import "./css/jokes.css"
const Jokes = () => {
    const  [punchline, setPunchline] = useState("loading....");
    const [setup,setSetup]=useState("Please Wait");
    const newjoke=()=>{
        fetch("https://dad-jokes.p.rapidapi.com/random/joke", {
            "method": "GET",
            "headers": {
                "x-rapidapi-host": "dad-jokes.p.rapidapi.com",
                "x-rapidapi-key": "b7662b32dfmsh7ec5b8c2ec1e380p108c25jsn44a89d058948"
            }
        })
        .then(response =>
            response.json()
        ).then(data=>{
            
            setSetup(data.body[0]["setup"])
            setPunchline(data.body[0]["punchline"])
        })
        .catch(err => {
            console.log(err.message);
            // setSetup(err.value);
        });
    }
    useEffect(()=>{
        newjoke();
    },[])
    
    return (
        
            <div className="jokes-container">
                <h1 className='jokes-heading'>Joke of day</h1>
                <div className='jokes-body'>
                    <p className='jokes-setup'>{setup}</p>
                    <p className='jokes-content'>{punchline}</p>
                    <button className="jokes-button" onClick={()=>newjoke()}>Get New Joke</button>
                </div>
            </div>

        
    )
}

export default Jokes
